import React, { createContext, useContext } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  // Tema sadece light mode
  const theme = 'light';
  
  const setTheme = () => {
    // Koyu mod kaldırıldı - hiçbir işlem yok
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
